<template>
  <v-card height="100%" class="cobrowsing__container">
  
    <div v-if="loadingMirroring" class="wz_loadingCobrowsing text-xs-center" >
      <v-progress-circular  :size="70" :width="1" indeterminate class="primary--text "></v-progress-circular>
    </div>

    <div class="vue-frame fill-height">
      {{socketConnected}}
      <div class="iconeClientPointer" ref="iconeClientPointer">
        <div class="pointerNameUser">
          {{ datasPupitreVisiteur.visiteurID }}
        </div>
      </div>
      <div class="ClickPointer" ref="ClickPointer"></div>
      <!-- <v-btn class="btnCobrow" @click.native="openCobrow()">openCobrow</v-btn> -->
      <div class="fill-height">
        <div v-if="cobrowsingAlertStatus" class="dialogueIframe">
          <v-card class="txtCenterCobrowsing">
            <v-card-title class="primary white--text subheading">{{ $t('visitorCloseCobrowsing') }}</v-card-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn 
                class="blue--text darken-1"
                flat
                @click="closeCobrowsing()"
              >{{txtBtCobrowsing}}</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      <div v-if="!cobrowsingMenuActif" class='maskIframe'></div>
        <iframe
          @mousemove="myMouseCoordinates"
          @scroll="myScrollTop"
          @click="myClickMouse"
          @keyup="myKeyPRESS"
          class="ClientView"
          :id="'ClientView_' + datasVisiteur.placePupitre"
          ref="iframeClientView"
        ></iframe>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cobrowsing from '../watcheebox/cobrowsing.js'
export default {
  data () {
    return {
      // infos pour le positionnement de la fenetre cobrowsing
      datasCobrowsingIframe: {
        'conteneurHauteur': 200,
        'conteneurLargeur': 200,
        'hauteur': 200,
        'largeur': 200,
        'ratio': 1,
        'posLeft': 100,
        'posTop': 100,
        'posPointeurLeft': 100,
        'posPointeurTop': 100
      },
      pointer: null,
      clickPointer: null,
      iframeCobrowsing: null,
      cobrowsingAlertStatus: false,
      mirroring: 0,
      conteneurCobrowsing: null,
      conteneurCobrowsingHeight: null,
      loadingMirroring: false,
      clientChangeVue: false,
      txtBtCobrowsing: 'Fermer',
      cobrowsing: null,
      timeoutVisiteur: null,
      socketConnected: this.socketIsConnected,
      cobrowsingMenuActif: false
    }
  },

  props: ['datasVisiteur', 'datasPupitreVisiteur', 'hauteurDiv'],

  sockets: {
    // demarrage de la session cobrowsing
    SessionCobrowsingStarted: function (data) {
      // console.log('### AdminMousePosition ###', data)
      // action uniquement pour le chat concerné
      // var cible = this.$el.getElementsByClassName('iconeClientPointer')[0]
      // if (this.datasVisiteur.visiteurID === data.chatSession) {
        // console.log(this.$el.firstChild)
        // this.cobrowsing.ClientMousePos(data, this.datasVisiteur, this.pointer, this.datasCobrowsingIframe)
      // }
    },

    // le visiteur active la session mirroring/cobrowsing
    SessionStarted: function (data) {
      console.log('### SessionStarted ###')
      this.cobrowsingAlertStatus = false
      // demarre la session mirroring
      // passe l'element mirroring
      // action uniquement pour le chat concerné
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        console.log("c'est uniquement pour " + data.chatSession)
        this.cobrowsing.SessionStarted(this.iframeCobrowsing)
      }
    },

    // DOM change
    changes: function (data) {
      // this.$el.lastChild c'est le contenu de l'iframe
      // action uniquement pour le chat concerné
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.mirrorChange(data, this.datasVisiteur, this.iframeCobrowsing, this.datasCobrowsingIframe)
        if (data.data.change.base) {
          // affichage du loader
          this.loadingMirroring = true
        }
        if (data.data.change.scroll) {
          // c'est le visiteur qui change la vue
          // console.log('change', data.data.change.scroll)
        }
        // positioonne la fenetre du cobrowsing
        this.fenetreCobrowPosition()
      }
    },

    // chargement du DOM
    DOM_Loaded: function (data) {
      // action uniquement pour le chat concerné
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.DOMLoadedOk(data, this.datasVisiteur)
        // positioonne la fenetre du cobrowsing
        this.loadingMirroring = false
      }
    },

    // position de la souris du visiteur sur ca page
    ClientMousePosition: function (data) {
      // action uniquement pour le chat concerné
      // var cible = this.$el.getElementsByClassName('iconeClientPointer')[0]
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.ClientMousePos(data, this.datasVisiteur, this.pointer, this.datasCobrowsingIframe, this.iframeCobrowsing)
      }
    },

    // le visiteur à cliqué sur la page
    ClientMouseClick: function (data) {
      // this.$el.childNodes[2] c'est le click souris
      // action uniquement pour le chat concerné
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.ClientMouseClick(data, this.datasVisiteur, this.clickPointer, this.datasCobrowsingIframe, this.iframeCobrowsing)
      }
    },

    // position de la souris de l'agent sur la page visiteur
    AdminMousePosition: function (data) {
      // action uniquement pour le chat concerné
      // var cible = this.$el.getElementsByClassName('iconeClientPointer')[0]
      // if (this.datasVisiteur.visiteurID === data.chatSession) {
        // console.log(this.$el.firstChild)
        // this.cobrowsing.ClientMousePos(data, this.datasVisiteur, this.pointer, this.datasCobrowsingIframe)
      // }
    },

    VisiteurCobrowsingStoped: function (data) {
      console.log('### VisiteurCobrowsingStoped ###', data)
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsingAlertStatus = true
        // var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
        // this.cobrowsing = null
      }
    }

  },

  watch: {
    'datasPupitreVisiteur.cobrowsing': function (val, oldval) {
      if (!val) {
        this.fermeCobrowsing()
      }
    },

    // regarde si le visiteur est toujour connecté
    'datasPupitreVisiteur.visiteurDatas.socketID': function (val, oldval) {
      console.log('datasPupitreVisiteur -->', val, oldval)
      if (!val) {
        // lance le timer pour savoir si le visiteur est vraiment parti
        this.timeoutVisiteur = setTimeout(() => {
          // il est vraiment parti
          if (!this.datasPupitreVisiteur.visiteurDatas.socketID) {
            if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') { // si uniquement en cobrowsing
              this.cobrowsingAlertStatus = true  // affiche la popup de deconnexion
            }
          }
        }, 10000)
      } else if (val !== oldval) {
        console.log('cobrowsing Menu Actif ?', this.datasPupitreVisiteur.visiteurDatas.menuSelected)
        if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
          // il a juste changé de page
          clearTimeout(this.timeoutVisiteur)
          this.cobrowsingAlertStatus = false
        }
      }
    },

    'cobrowsingActif': function (val, oldval) {
    },

    'isConnected': function (val, oldval) {
      console.log('-> isConnected : ', val)
    }
  },

  methods: {
    // Demarrage d'une session cobrowsing
    openCobrow () {
      this.loadingMirroring = true
      console.log('openCobrow')
      console.log(this.datasVisiteur)
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      // si c'est du mirroring (regarde si le menu cobrowsing est actif, donc pas encore utilisé)
      let isCobrowsing = false
      if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
        isCobrowsing = true
      }
      console.log('isCobrowsing', isCobrowsing)
      console.log('agentSocketID', agentSocketID)
      console.log('socket', this.$socket)
      this.cobrowsing.startSession(agentSocketID, this.user, this.datasVisiteur, isCobrowsing)
    },

    // ferme le cobrowsing via le bouton "iconethis.cobrowsingOpen"
    fermeCobrowsing () {
      console.log('ferme cobrowsing', this.datasVisiteur)
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      this.cobrowsing.fermeCobrowsing({'agentSocketID': agentSocketID, 'datasAgent': this.user, 'datasVisiteur': this.datasVisiteur})
    },

    closeCobrowsing () {
      console.log('close')
      this.cobrowsingAlertStatus = false
      this.$emit('closeCobrowsing') // close le cobrowsing apres iterruption du visiteur
    },

    // centre la fenetre du cobrowsing en fonction de ca taille
    fenetreCobrowPosition: function () {
      // recupere la taille de la fenetre contenant le cobrowsing
      this.datasCobrowsingIframe.conteneurHauteur = this.conteneurCobrowsing.offsetHeight
      this.datasCobrowsingIframe.conteneurLargeur = this.conteneurCobrowsing.offsetWidth

      // recupere les changement de la fenetre cobrowsing
      this.datasCobrowsingIframe.hauteur = this.iframeCobrowsing.offsetHeight
      this.datasCobrowsingIframe.largeur = this.iframeCobrowsing.offsetWidth

      // recupere la bonne position XY du cobrowsing
      var rect = this.iframeCobrowsing.getBoundingClientRect()
      this.datasCobrowsingIframe.posLeft = Math.floor(rect.left)
      this.datasCobrowsingIframe.posTop = Math.floor(rect.top)
      var decalHauteur = (this.datasCobrowsingIframe.conteneurHauteur / 2) - ((this.datasCobrowsingIframe.hauteur) / 2)
      var decalLargeur = (this.datasCobrowsingIframe.conteneurLargeur / 2) - ((this.datasCobrowsingIframe.largeur) / 2)

      // calcule des ratios
      var ratioLargeur = (this.datasCobrowsingIframe.conteneurLargeur / this.datasCobrowsingIframe.largeur)
      var ratioHauteur = (this.datasCobrowsingIframe.conteneurHauteur / this.datasCobrowsingIframe.hauteur)

      // Si le conteneur cobrowsing est plus grande que le cobrowsing
      if (this.datasCobrowsingIframe.largeur < this.datasCobrowsingIframe.conteneurLargeur && this.datasCobrowsingIframe.hauteur < this.datasCobrowsingIframe.conteneurHauteur) {
        this.datasCobrowsingIframe.ratio = 1 // ratio max à 1
      } else {
        // Sinon je prend le ration le plus petit entre la hauteur et la largeur
        this.datasCobrowsingIframe.ratio = Math.min(ratioLargeur, ratioHauteur)
      }
      this.iframeCobrowsing.style.webkitTransform = 'translate(' + decalLargeur + 'px, ' + decalHauteur + 'px) scale(' + this.datasCobrowsingIframe.ratio + ')'
      this.iframeCobrowsing.style.transform = 'translate(' + decalLargeur + 'px, ' + decalHauteur + 'px) scale(' + this.datasCobrowsingIframe.ratio + ')'
      // this.cobrowsing.style.webkitTransform = 'translateY(-' + decalHauteur + 'px)'
      // this.cobrowsing.style.webkitTransform = 'scale(' + this.datasCobrowsingIframe.ratio + ')'
      // this.cobrowsing.setAttribute('style', 'translate(-' + decalLargeur + 'px, -' + decalHauteur + 'px)')
    },

    myMouseCoordinates (event) {
      // divise par le ratio de reduction poour renvoyer la bonne position au visiteur
      let posLeft = Math.round(event.pageX)
      let posTop = Math.round(event.pageY)
      this.cobrowsing.AgentEvent(
        {
          'typeEvent': 'mousePos',
          'datasVisiteur': this.datasVisiteur,
          'dataEvent': {
            'posLeft': posLeft,
            'posTop': posTop
          }
        }
      )
    },

    myScrollTop (event) {
      // if (this.cobrowsingActif) {
      // divise par le ratio de reduction poour renvoyer la bonne position au visiteur
      this.cobrowsing.AgentEvent(
        {
          'typeEvent': 'scrollPage',
          'datasVisiteur': this.datasVisiteur,
          'dataEvent': {
            'scrollTop': event.scrollTop
          }
        }
      )
    },

    myClickMouse (event) {
      console.log('clickMouse', event.mouseClickDiv)
      this.cobrowsing.AgentEvent(
        {
          'typeEvent': 'clickMouse',
          'datasVisiteur': this.datasVisiteur,
          'dataEvent': {
            'eventClick': event.mouseClickDiv
          }
        }
      )
    },

    myKeyPRESS (event) {
      this.cobrowsing.AgentEvent(
        {
          'typeEvent': 'keyPress',
          'datasVisiteur': this.datasVisiteur,
          'dataEvent': {
            'eventKeyUP': event.mouseKeyUp
          }
        }
      )
    },

    // Event pour le mirroring
    bindIFrameEventMirroring (iframe) {
      // bloque le scroll
      this.$el.parentNode.addEventListener('scroll', function (event) {
        // this.scrollTo(0, 0) // ca bloque partout apres
      })
    },

    // Event pour le cobrowsing
    bindIFrameEventCobrowsing (iframe) {
      var _this = this
      if (this.hauteurDiv) {
        this.$emit('update:hauteurDiv', this.hauteurDiv + 100)
      }
      // la position de la souris dans l'iframe
      iframe.contentWindow.addEventListener('mousemove', function (event) {
        var evt = new CustomEvent('mousemove', {bubbles: true, cancelable: false})
        evt.pageX = event.pageX
        evt.pageY = event.pageY
        iframe.dispatchEvent(evt)
      })

      iframe.contentWindow.addEventListener('scroll', function (event) {
        _this.cobrowsing.clientScrollView('scroll', function (returnData) {
          if (!returnData.clientScroll) {
            if (event.target.scrollingElement.scrollTop) {
              var evt = new CustomEvent('scroll', {bubbles: true, cancelable: false})
              evt.scrollTop = event.target.scrollingElement.scrollTop
              iframe.dispatchEvent(evt)
            }
          }
        })
      })

      // le click souris dans l'iframe
      iframe.contentWindow.addEventListener('click', function (event) {
        var evt = new CustomEvent('click', {bubbles: true, cancelable: false})
        var hrefReference = ''
        // self.myClickMouse(event)
        // si c'est autre chose qu'un ellement de formulaire
        if (event.target.tagName !== 'SELECT' && event.target.tagName !== 'INPUT' && event.target.tagName !== 'BUTTON') {
          if (!event.target.onclick && !event.target.href) {
            if (event.target.parentElement.tagName !== 'SELECT' && event.target.parentElement.tagName !== 'INPUT' && event.target.parentElement.tagName !== 'BUTTON') {
              if (!event.target.parentElement.onclik && !event.target.parentElement.href) {
                // si c'est autre chose qu'un ellement de formulaire
                if (event.target.parentElement.parentElement.tagName !== 'SELECT' && event.target.parentElement.parentElement.tagName !== 'INPUT' && event.target.parentElement.parentElement.tagName !== 'BUTTON') {
                  if (!event.target.parentElement.parentElement.onclik && !event.target.parentElement.parentElement.href) {
                    // si c'est autre chose qu'un ellement de formulaire
                    if (event.target.parentElement.parentElement.parentElement.tagName !== 'SELECT' && event.target.parentElement.parentElement.parentElement.tagName !== 'INPUT' && event.target.parentElement.parentElement.parentElement.tagName !== 'BUTTON') {
                      if (!event.target.parentElement.parentElement.parentElement.onclik && !event.target.parentElement.parentElement.parentElement.href) {
                        console.log('pas trouvé d\'evenement au 4eme niveau')
                        evt.mouseClickDiv = {
                          'id': event.target.parentElement.parentElement.parentElement.id,
                          'className': event.target.parentElement.parentElement.parentElement.className,
                          'mousePosX': event.pageX,
                          'mousePosY': event.pageY
                        }
                      } else {
                        console.log('niveau -3')
                        // si le lien est '#' il ne faut pas l'utiliser
                        // mais plutot la 'onclick' car il et surement la
                        if (event.target.parentElement.parentElement.parentElement.attributes.href.value && event.target.parentElement.parentElement.parentElement.attributes.href.value !== '#') {
                          hrefReference = event.target.parentElement.parentElement.parentElement.href
                        }
                        evt.mouseClickDiv = {
                          'id': event.target.parentElement.parentElement.parentElement.id,
                          'href': hrefReference,
                          'type': event.target.parentElement.parentElement.parentElement.type,
                          'tagName': event.target.parentElement.parentElement.parentElement.tagName,
                          'selectedIndex': event.target.parentElement.parentElement.parentElement.selectedIndex,
                          'checked': event.target.parentElement.parentElement.parentElement.checked,
                          'value': event.target.parentElement.parentElement.parentElement.value,
                          'name': event.target.parentElement.parentElement.parentElement.name,
                          'className': event.target.parentElement.parentElement.parentElement.className,
                          'mousePosX': event.pageX,
                          'mousePosY': event.pageY
                        }
                      }
                    // sinon c'est du formulaire
                    } else {
                      evt.mouseClickDiv = {
                        'id': event.target.parentElement.parentElement.parentElement.id,
                        'href': event.target.parentElement.parentElement.parentElement.href,
                        'type': event.target.parentElement.parentElement.parentElement.type,
                        'tagName': event.target.parentElement.parentElement.parentElement.tagName,
                        'selectedIndex': event.target.parentElement.parentElement.parentElement.selectedIndex,
                        'checked': event.target.parentElement.parentElement.parentElement.checked,
                        'value': event.target.parentElement.parentElement.parentElement.value,
                        'name': event.target.parentElement.parentElement.parentElement.name,
                        'className': event.target.parentElement.parentElement.parentElement.className,
                        'mousePosX': event.pageX,
                        'mousePosY': event.pageY
                      }
                    }
                  } else {
                    console.log('niveau -2')
                    // si le lien est '#' il ne faut pas l'utiliser
                    // mais plutot la 'onclick' car il et surment la
                    if (event.target.parentElement.parentElement.attributes.href.value && event.target.parentElement.parentElement.attributes.href.value !== '#') {
                      hrefReference = event.target.parentElement.parentElement.href
                    }
                    evt.mouseClickDiv = {
                      'id': event.target.parentElement.parentElement.id,
                      'href': hrefReference,
                      'type': event.target.parentElement.parentElement.type,
                      'tagName': event.target.parentElement.parentElement.tagName,
                      'selectedIndex': event.target.parentElement.parentElement.selectedIndex,
                      'checked': event.target.parentElement.parentElement.checked,
                      'value': event.target.parentElement.parentElement.value,
                      'name': event.target.parentElement.parentElement.name,
                      'className': event.target.parentElement.parentElement.className,
                      'mousePosX': event.pageX,
                      'mousePosY': event.pageY
                    }
                  }
                // sinon c'est du formulaire
                } else {
                  evt.mouseClickDiv = {
                    'id': event.target.parentElement.parentElement.id,
                    'href': event.target.parentElement.parentElement.href,
                    'type': event.target.parentElement.parentElement.type,
                    'tagName': event.target.parentElement.parentElement.tagName,
                    'selectedIndex': event.target.parentElement.parentElement.selectedIndex,
                    'checked': event.target.parentElement.parentElement.checked,
                    'value': event.target.parentElement.parentElement.value,
                    'name': event.target.parentElement.parentElement.name,
                    'className': event.target.parentElement.parentElement.className,
                    'mousePosX': event.pageX,
                    'mousePosY': event.pageY
                  }
                }
              } else {
                console.log('niveau -1')
                console.log(event.target.parentElement.attributes.href.value)
                // si le lien est '#' il ne faut pas l'utiliser
                // mais plutot la 'onclick' car il et surment la
                if (event.target.parentElement.attributes.href.value && event.target.parentElement.attributes.href.value !== '#') {
                  hrefReference = event.target.parentElement.href
                }
                evt.mouseClickDiv = {
                  'id': event.target.parentElement.id,
                  'href': hrefReference,
                  'type': event.target.parentElement.type,
                  'tagName': event.target.parentElement.tagName,
                  'selectedIndex': event.target.parentElement.selectedIndex,
                  'checked': event.target.parentElement.checked,
                  'value': event.target.parentElement.value,
                  'name': event.target.parentElement.name,
                  'className': event.target.parentElement.className,
                  'mousePosX': event.pageX,
                  'mousePosY': event.pageY
                }
              }
            // sinon c'est du formulaire
            } else {
              evt.mouseClickDiv = {
                'id': event.target.parentElement.id,
                'href': event.target.parentElement.href,
                'type': event.target.parentElement.type,
                'tagName': event.target.parentElement.tagName,
                'selectedIndex': event.target.parentElement.selectedIndex,
                'checked': event.target.parentElement.checked,
                'value': event.target.parentElement.value,
                'name': event.target.parentElement.name,
                'className': event.target.parentElement.className,
                'mousePosX': event.pageX,
                'mousePosY': event.pageY
              }
            }
          } else {
            console.log('niveau 0')
            console.log('event.target', event.target)
            // si le lien est '#' il ne faut pas l'utiliser mais plutot la 'onclick'
            if (event.target.attributes.href && event.target.attributes.href.value !== '#') {
              hrefReference = event.target.href
            }
            evt.mouseClickDiv = {
              'id': event.target.id,
              'href': hrefReference,
              'type': event.target.type,
              'tagName': event.target.tagName,
              'selectedIndex': event.target.selectedIndex,
              'checked': event.target.checked,
              'value': event.target.value,
              'name': event.target.name,
              'className': event.target.className,
              'mousePosX': event.pageX,
              'mousePosY': event.pageY
            }
          }
        // sinon c'est du formulaire
        } else {
          console.log('click mouse sur :', event.target.type)
          evt.mouseClickDiv = {
            'id': event.target.id,
            'href': event.target.href,
            'type': event.target.type,
            'tagName': event.target.tagName,
            'selectedIndex': event.target.selectedIndex,
            'checked': event.target.checked,
            'value': event.target.value,
            'name': event.target.name,
            'className': event.target.className,
            'mousePosX': event.pageX,
            'mousePosY': event.pageY
          }
        }
        iframe.dispatchEvent(evt)
        event.preventDefault() // annuler l'evenement 'click' dans l'iframe
      })

      iframe.contentWindow.addEventListener('keyup', function (event) {
        var evt = new CustomEvent('keyup', {bubbles: true, cancelable: false})
        // var contentTXT = ''
        console.log('keyUp', event)
        // si c'est un textarea
        if (event.target.nodeName === 'TEXTAREA') {
            // contentTXT = event.target.innerHTML + event.key
        } else if (event.target.nodeName === 'INPUT') {
          console.log('un input')
        }
        evt.mouseKeyUp = {
          'id': event.target.id,
          'href': event.target.href,
          'type': event.target.type,
          'tagName': event.target.tagName,
          'selectedIndex': event.target.selectedIndex,
          'value': event.target.value,
          'name': event.target.name,
          'className': event.target.className,
          'mousePosX': event.pageX,
          'mousePosY': event.pageY
        }
        iframe.dispatchEvent(evt)
        event.preventDefault() // annuler l'evenement 'keypress' dans l'iframe
      })
    }
  },

  computed: {
    ...mapGetters('_User', ['user']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_StoreWatcheeBox', ['cobrowsingActif', 'isConnected'])
    // hauteurDivCobrowsing () {
    //   if (this.cobrowsingMenuActif) {
    //     return this.hauteurDiv
    //   } else {
    //     return this.hauteurDiv
    //   }
    // }
  },

  mounted () {
    this.cobrowsing = new Cobrowsing()
    this.openCobrow()
    // cible tous les elements necessaire au cobrowsing
    this.pointer = this.$refs.iconeClientPointer
    this.clickPointer = this.$refs.ClickPointer
    this.iframeCobrowsing = this.$refs.iframeClientView
    this.conteneurCobrowsing = this.$el
    var rect = this.pointer.getBoundingClientRect()
    console.log('rect', rect)
    this.datasCobrowsingIframe.posPointeurLeft = Math.floor(rect.left)
    this.datasCobrowsingIframe.posPointeurTop = Math.floor(rect.top)
    console.log('this.datasCobrowsingIframe', this.datasCobrowsingIframe)
    // if (!this.cobrowsingMenuActif) {
    if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
      this.bindIFrameEventCobrowsing(this.iframeCobrowsing)
      this.cobrowsingMenuActif = true
    } else {
      this.bindIFrameEventMirroring(this.iframeCobrowsing)
      this.cobrowsingMenuActif = false
    }
    console.log('this.cobrowsing', this.cobrowsing)
  },

  beforeDestroy () {
    console.log('beforeDestroy')
    this.fermeCobrowsing()
  }
}
</script>

<style>
/*
.vb-dragger {
  display: none !important;
}
*/
/* #vwatch {
  display: none !important;
} */
#ClientView_1#vwatch {
  display: none !important;
}
.wz_loadingCobrowsing {
  position: absolute;
  z-index: 100;
  top: calc(50% - 35px);
  left: calc(50% - 35px);
}
.vue-frame {
  z-index: 0;
}
.maskIframe {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
}
.dialogueIframe {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
}
.txtCenterCobrowsing {
  position: absolute;
  top: calc(50% - 100px);
  left: calc(50% - 150px);
  width: 300px;
}
.ClientView {
  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
  border: 1px solid #888;
}

.iconeClientPointer {
  transition: all .2s;
  z-index: 10;
  width: 20px;
  height: 20px;
  border-radius: 50% 50% 50% 0;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  background-color: #E74011;
  vertical-align: middle;
  position: fixed;
}
.pointerNameUser {
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  bottom: 72px;
  left: -50px;
  font-size: 0.8em;
  position: relative;
  background-color: rgba(255, 255, 255, 0.5);
  height: 16px;
  width: 120px;
  padding-left: 6px;
  border-radius: 4px;
}

.iconeClientPointer:before {
  content: '';
  /* position: absolute; */
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FFF;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}

.iconeClientPointer:after {
  content: '';
  pointer-events: none;
}

.ClickPointer {
  opacity: 0;
  position: fixed;
  width: 1px;
  height: 1px;
  border-radius: 100px;
  border: 4px solid #E74011;
  text-align: center;
  z-index: 2;
}
.ClickPointer.click {
  animation:anim 0.8s;
  -webkit-animation:anim 0.8s;
}
.btnCobrow {
  position: absolute;
  top: 2px;
  left: 2px;
}
@keyframes anim {
  50%{
    width: 50px;
    height: 50px;
    margin-top: -25px;
    margin-left: -25px;
    opacity: 0.8;
  }
  100%{
    opacity: 0;
  }
}
@-webkit-keyframes anim {
  50%{
    width: 50px;
    height: 50px;
    margin-top: -25px;
    margin-left: -25px;
    opacity: 0.8;
  }
  100%{
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzCobrowsingClient.vue